import { render, staticRenderFns } from "./awards-section.vue?vue&type=template&id=a1f07e28"
import script from "./awards-section.vue?vue&type=script&lang=js"
export * from "./awards-section.vue?vue&type=script&lang=js"
import style0 from "./awards-section.vue?vue&type=style&index=0&id=a1f07e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports